<template>
  <div class="index">
    <img src="../../../assets/shared-hotel/loading.gif" />
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
      sessionStorage.setItem("token", JSON.stringify(this.$route.query.token));
    }
    this.initData();
  },
  mounted() {},
  methods: {
    initData() {
      this.$api.get("decoration/member/city/partner/area/list").then((res) => {
        let path = "";
        let query = {};
        if (res.area.length > 1) {
          path = "/decoration/cityPartner/citySelect";
        } else {
          path = "/decoration/cityPartner/details";
          query = {
            area_id: res.area[0].id,
          };
        }
        this.$router.push({
          path: path,
          query: query,
        });
      });
    },
  },
};
</script>
<style lang="less">
.index {
  text-align: center;
  width: 100%;
  height: 100%;
  img {
    width: 35%;
    margin-top: 65%;
  }
}
</style>